import React, { useState } from "react";
import infoIcon from "./assets/iconInfo.svg";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

import BannerDigital from "components/layout/portal/banner";
import BillsMenuIcon from "components/MI/BillsMenuIcon";
import ModalContent from "components/Boletos/ModalContent";
import api from "services/api";
import { normalizeBillStatus } from "utils/functions";

import {
  ContentActions,
  ContentItem,
  Info,
  MonthYear,
  StatusCard,
  StatusContent,
  StatusWrapper,
} from "./styles";

const status = {
  VENCIDO: "Vencido",
  PAGO: "Pago",
  A_VENCER: "A vencer",
};

const Item = ({ data: { invoice, installment } }: any): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [loadingMenu, setLoadingMenu] = useState(false);
  const [cookies, setCookie] = useCookies(["bannerIsViewer"]);

  const normalizedStatus = normalizeBillStatus(
    invoice?.status,
    invoice?.totalAmount
  );

  const toggleModal = (): void => {
    setShowModal((prevState) => !prevState);
  };

  const handleShow = (): void => {
    const { deliveryType } = JSON.parse(
      localStorage.getItem("@UltragazEmpresarial:unitData")
    );
    const cookieBannerIsViewer = cookies?.bannerIsViewer;

    if (deliveryType === "CORREIO" && !cookieBannerIsViewer) {
      setCookie("bannerIsViewer", "true", {
        maxAge: 60 * 60 * 24 * 7, // 1 semana
      });

      setShowBanner(true);
    }

    if (invoice && installment) {
      setShowModal(true);
    }
  };

  const handleCloseBanner = (): void => {
    setShowModal(true);
    setShowBanner(false);
  };

  const sendEmail = async (): Promise<void> => {
    setLoadingMenu(true);
    toast.dismiss();
    const accessToken = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );

    try {
      const headers = {
        access_token: accessToken,
      };

      const body = {
        deliveryMethod: "EMAIL",
      };
      await api.post(`industrial/bill/v1/bills/${invoice?.id}`, body, {
        headers,
      });
      toast.success(`Boleto enviado para o e-mail cadastrado`);
    } catch (err) {
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
    setLoadingMenu(false);
  };

  const downloadBill = async (): Promise<void> => {
    setLoadingMenu(true);
    const accessToken = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    try {
      const headers = {
        access_token: accessToken,
      };
      const body = {
        deliveryMethod: "DOWNLOAD",
        isReduced: false,
      };
      const response = await api.post(
        `industrial/bill/v1/bills/${invoice.id}`,
        body,
        { headers, responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const referenceMonth = (installment.referenceMonth || "").split("/");
      link.setAttribute(
        "download",
        `Ultragaz_${moment(`${referenceMonth[1]}/01/${referenceMonth[0]}`)}_${
          invoice.id
        }.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
    setLoadingMenu(false);
  };

  return (
    <>
      <ContentItem>
        <MonthYear>
          <span>
            {moment(`${invoice?.referenceMonth}/01` ?? "")?.format("MMM")}
          </span>
          <span>
            {moment(`${invoice?.referenceMonth}/01` ?? "")?.format("yyyy")}
          </span>

          <StatusContent>
            <StatusCard status={normalizedStatus} />
          </StatusContent>
        </MonthYear>
        <Info>
          <span>Vencimento</span>
          <span>{moment(invoice?.dueDate ?? "")?.format("DD/MM/yyyy")}</span>
        </Info>
        <Info>
          <span>Valor</span>
          <span>
            {Intl.NumberFormat("pt-br", {
              style: "currency",
              currency: "BRL",
            }).format(invoice?.totalAmount?.replace(",", "."))}
          </span>
        </Info>
        <Info hiddenMobile isFixedWidth>
          <span>Situação</span>
          <StatusWrapper hasIcon={normalizedStatus === "VENCIDO"}>
            <StatusCard status={normalizedStatus} />
            {status[normalizedStatus]}
            {normalizedStatus === "VENCIDO" && (
              <img src={infoIcon} alt="Boleto vencido" />
            )}
          </StatusWrapper>
        </Info>
        <ContentActions>
          <BillsMenuIcon
            sendEmail={sendEmail}
            openModal={handleShow}
            download={downloadBill}
            loading={loadingMenu}
          />
        </ContentActions>
      </ContentItem>
      <Modal
        show={showModal}
        onHide={toggleModal}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalContent
          // @ts-ignore
          payment={invoice}
          installment={installment}
          close={toggleModal}
        />
      </Modal>
      <BannerDigital show={showBanner} onClose={handleCloseBanner} />
    </>
  );
};

export default Item;
